import { Segmented } from 'antd'

import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { pick } from '@eastcoal/common/utils/object'

import { AuctionOperationPageStatus } from '../../../enums/AuctionOperationPageStatus'

const options = [
  {
    label: '待发布',
    value: [AuctionOperationPageStatus.WAIT_PUBLISH].toString()
  },
  {
    label: '待审核',
    value: [AuctionOperationPageStatus.WAIT_AUDIT].toString()
  },
  {
    label: '待开始',
    value: [AuctionOperationPageStatus.WAIT_START].toString()
  },
  {
    label: '进行中',
    value: [AuctionOperationPageStatus.BIDDING].toString()
  },
  {
    label: '已结束', // 已确认，已结束，申请终止，终止未通过
    value: [
      AuctionOperationPageStatus.ENTRUST_CONFIRMED,
      AuctionOperationPageStatus.END,
      AuctionOperationPageStatus.ENTRUST_HALT,
      AuctionOperationPageStatus.HALT_FAIL
    ].toString()
  },
  {
    label: '确认结束', // 已成交，已流拍，已终止
    value: [
      AuctionOperationPageStatus.DEAL,
      AuctionOperationPageStatus.DEAL_PART,
      AuctionOperationPageStatus.DEAL_FAIL,
      AuctionOperationPageStatus.HALT_SUCCESS
    ].toString()
  },
  {
    label: '全部',
    value: ''
  }
]

export const AuctionListStatusSegmented = () => {
  const { request, requestParams } = useRemoteTableStore(state =>
    pick(state, ['request', 'requestParams'])
  )
  const value = requestParams['statusList']?.toString()
  return (
    <Segmented
      options={options}
      value={value}
      onChange={value => request({ statusList: value })}
    />
  )
}
